Revolution.Module.extend({
    NAME: "mde.nav", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        _.bindAll(this, "showBtnExpendTouch");
        //
        this.initEnquireResetStyles();

        //events


        //Open submenu headerSup
        $('body').on('click', '.js-toggle-sub-menu', this.toggleSubMenu);
        $('body').on('click', '.js-close-sub-menu', this.closeSubMenus);
        this.setSubMenuTop();
        this.setSubMobMenuTop();
        $('body').click(this.closeSubMenus);

        $('body').on('click', '.js-toggle-sub-menu, .sub-menu', function(e) {
            e.stopPropagation();
        });


        $('.js-toggle-mob-nav').on('click', this.toggleMobileMenu);
        $('.header-menu').keydown(this.tabInLayer);

        // $('.main-nav .li-level-1').on('mouseenter', this.navMouseEnter);
        // $('.main-nav .li-level-1').on('mouseleave', this.navMouseLeave);

        $('.global-wrapper').click(this.clickOutsideHeader);

        $('.main-nav .lk-level-1 .btn-expend').on('click', this.toggleLevel2);

        if (Modernizr.touchevents && $(window).width() < 1025) {
            this.showBtnExpendTouch();
        }

        this.setBodyPadding();

    },

    onWindowLoad: function (e) {
        this.cloneHeaderTop();
    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {
        this.setSubMenuTop();
        this.setSubMobMenuTop();
        this.setBodyPadding();

        $('.main-nav .li-level-1').removeClass('active');
    },

    setBodyPadding: function () {
        var headerH = $('.page-header-wrapper').outerHeight();
        var BodyPaddingT = parseInt($('body').css('padding-top'));

        if (BodyPaddingT !== headerH) {
            $('body').css('padding-top', headerH+'px');
            $('.bk-sidebar').css('top', headerH+'px');
        }
    },

    tabInLayer: function (e) {
        var $obj = $(e.currentTarget);
        if($('.btn-nav-mob').is(':visible')) {
            var ACCESS = Revolution.get("mde.accessible-function");
            ACCESS.trapTabKey($obj, e);
            ACCESS.trapEscapeKey($obj, e);
        }
    },

    closeSubMenus: function(e) {
        $('.sub-menu:visible').slideUp().prev('.js-toggle-sub-menu').removeClass('active').attr('aria-expanded', "false");
    },

    cloneHeaderTop: function () {
        $('.js-header-top > li').each(function (index, elem) {
            $cloneItem = $(elem).clone();
            $cloneItem.addClass('duplicate-item');
            $('.js-ul-main-nav').append($cloneItem);
        })
    },

    setSubMobMenuTop: function() {
        $menu = $('.header-menu');
        headerH = $('.page-header-wrapper').height();
        $menu.css('top', headerH);
    },

    setSubMenuTop:function () {
        var $buttonsSubMenu = $('.header-sup .js-toggle-sub-menu');
        $buttonsSubMenu.each(function(index, elem){
            var $subMenu = $(elem).next('.sub-menu');
            var top = $(window).scrollTop() - $(elem).offset().top + $(elem).outerHeight();
            $subMenu.css('top', top);
        });
    },

    toggleSubMenu: function (e) {
        var $obj = $(e.currentTarget);
        var $subMenu = $obj.next('.sub-menu');
        if (!$obj.hasClass('active')) {
            $('.page-header-wrapper .sub-menu:visible').hide();
            $subMenu.slideDown();
            $obj.addClass('active').attr('aria-expanded', 'true');
        } else {
            $subMenu.slideUp();
            $obj.removeClass('active').attr('aria-expanded', 'false');
        }
    },


    navMouseEnter: function (e) {
        var UTILS = Revolution.get("mde._utils");
        $obj = $(e.currentTarget);
        if (UTILS.isMenuDesktop() && !Modernizr.touchevents) {
            $obj.addClass('active');
            if ($('.level-2-wrapper:visible').length) {
                $obj.find('.level-2-wrapper').addClass('open').stop().show();
            } else {
                $obj.find('.level-2-wrapper').addClass('open').stop().fadeIn();
            }
        }
    },
    navMouseLeave: function (e) {
        $obj.removeClass('active');
        var UTILS = Revolution.get("mde._utils");
        $obj = $(e.currentTarget);
        if (UTILS.isMenuDesktop() && !Modernizr.touchevents) {
            $obj.find('.level-2-wrapper').removeClass('open').stop().fadeOut(10);
        }
    },

    clickOutsideHeader: function (e) {
        var UTILS = Revolution.get("mde._utils");
        $obj = $(e.target);
        $header = $('.page-header-wrapper');
        if (UTILS.isMenuDesktop() && $header.find('.open').length) {
            if (!$obj.closest('.header-bottom').length) {
                $header.find('.level-2-wrapper').removeClass('open').stop().fadeOut(10);
                $header.find('.li-level-1').removeClass('active');
            }
        }
    },

    reinitMobileMenu: function () {
        $('body').attr('overflow', '');
        $('header [style]:not(.submenu-overlay)').removeAttr('style');
        $('header .open').removeClass('open');
    },

    initEnquireResetStyles: function () {
        enquire.register("screen and (min-width:1023px)", {
            match: _.bind(function () {
                this.reinitMobileMenu();
            }, this),
            unmatch: _.bind(function () {
                this.reinitMobileMenu();
            }, this)
        });
    },

    toggleMobileMenu: function (e) {
        e.preventDefault();
        $obj = $(e.currentTarget);
        $mobileNav = $('.main-nav');

        if ($obj.hasClass('open')) {
            $obj.removeClass('open');
            $mobileNav.stop().fadeOut();
            $('body').css('overflow', '');
        } else {
            $obj.addClass('open');
            $mobileNav.stop().fadeIn();
            $('body').css('overflow', 'hidden');
        }
    },

    toggleLevel2: function (e) {
        e.preventDefault();
        $obj = $(e.currentTarget);
        $currentLi = $obj.closest('li');
        $currentLevel2 = $currentLi.find('.level-2-wrapper');
        $mobileNav = $('.main-nav');
        var UTILS = Revolution.get("mde._utils");

        if (UTILS.isMenuMobile()) { //MOBILE

            if ($currentLi.hasClass('open')) { // BACK TO LEVEL 1
                $currentLi.removeClass('open');
                $currentLevel2.stop().slideUp();
                $mobileNav.find('.li-level-1').not(':visible').stop().slideDown();
            } else { // GO TO LEVEL 2
                $currentLi.addClass('open');
                $currentLevel2.stop().slideDown();
                $mobileNav.find('.li-level-1').not('.open').stop().slideUp();
            }

        } else  { //DESKTOP

            if ($currentLevel2.hasClass('open')) { //close
                $currentLi.removeClass('active');
                $currentLi.find('.level-2-wrapper').removeClass('open').stop().fadeOut();
            } else {// open
                //close opened nav
                $mobileNav.find('.active').removeClass('active');
                $mobileNav.find('.open').removeClass('open');
                $mobileNav.find('.level-2-wrapper').stop().fadeOut();

                //open current
                $currentLi.addClass('active');
                $currentLi.find('.level-2-wrapper').addClass('open').stop().fadeIn();

            }
        }

    },

    showBtnExpendTouch: function () {
        $('.page-header-wrapper .main-nav .li-level-1 .btn-expend').show();
    }


});
